import styled from "styled-components";

export const Container = styled.div`
  .grid line {
    stroke: ${({ theme }) => theme.styleGuide.colors.gray[500]};
    shape-rendering: crispEdges;
  }

  .grid path {
    stroke-width: 0;
  }

  .x-axis line,
  .y-axis line {
    stroke: transparent;
  }

  .x-axis path,
  .y-axis path {
    stroke: transparent;
  }

  text {
    font-family: ${({ theme }) => theme.styleGuide.fonts.sansSerif};
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 2.2rem;
    fill: ${({ theme }) => theme.styleGuide.colors.gray[800]};

    ${({ theme }) => theme.media.sm`
      font-size: 1.7rem;
      line-height: 2.4rem;
    `}
  }

  .x-label {
    fill: ${({ theme }) => theme.styleGuide.colors.gray[700]};
  }
`;
